

export const txnTypeOptions = [
    { id: 'PAYMENT', name: 'Payment' },
    { id: 'DISCOUNT', name: 'Discount' },
    { id: 'WRITE_OFF', name: 'Write-off' },
    { id: 'ADJUSTMENT', name: 'Adjustment' },
];

export const reasonOptionsByType = {
    PAYMENT: [
        { id: 'Insurance Payment', name: 'Insurance Payment' },
        { id: 'Client Payment', name: 'Client Payment' },
        { id: 'Co-Pay', name: 'Co-Pay' },
        { id: 'Other', name: 'Other' },
    ],
    ADJUSTMENT: [
        { id: 'Billing Error', name: 'Billing Error' },
        { id: 'Rate Adjustment', name: 'Rate Adjustment' },
        { id: 'Insurance Adjustment', name: 'Insurance Adjustment' },
        { id: 'Other', name: 'Other' },
    ],
    WRITE_OFF: [
        { id: 'Uncollectible', name: 'Uncollectible' },
        { id: 'Timely Filing', name: 'Timely Filing' },
        { id: 'Contractual Write-off', name: 'Contractual Write-off' },
        { id: 'Other', name: 'Other' },
    ],
    DISCOUNT: [
        { id: 'Prompt Payment', name: 'Prompt Payment' },
        { id: 'Financial Hardship', name: 'Financial Hardship' },
        { id: 'Courtesy Discount', name: 'Courtesy Discount' },
        { id: 'Other', name: 'Other' },
    ],
};